module.exports = __webpack_public_path__ + "static/cocoa_cake_slika5-61736c68d2c6410319ce1e4ae8ce3427.jpg";